module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.9a3bf7ac.woff";